export const SET_SHOULD_SCROLL_TO_ERROR = 'set-should-scroll-to-error';

/**
 * @param  {boolean} [shouldScrollToError]
 *         if we should scroll to the highest required field with an error
 * @return {{payload: boolean, type: string}}
 *         redux action
 */
export default function setShouldScrollToError(shouldScrollToError) {
  return {
    type: SET_SHOULD_SCROLL_TO_ERROR,
    payload: shouldScrollToError,
  };
}
